import type {
	EVENT_TYPE,
	ACTION_SUBJECT,
	ACTION_SUBJECT_ID,
	EditorAnalyticsAPI,
	AnalyticsEventPayload,
} from '@atlaskit/editor-common/analytics';

// From `packages/editor/editor-common/src/analytics/types/utils.ts`
type AEP<
	Action,
	ActionSubject extends ACTION_SUBJECT,
	ActionSubjectID extends ACTION_SUBJECT_ID | undefined,
	Attributes,
	NonPrivacySafeAttributes extends Object = {},
	EventType extends EVENT_TYPE = EVENT_TYPE.TRACK,
	ImplicitAttributes extends Object = {},
> = {
	action: Action;
	actionSubject: ActionSubject;
	actionSubjectId?: ActionSubjectID;
	attributes?: Attributes & {
		[key in keyof ImplicitAttributes]?: ImplicitAttributes[key];
	};
} & (
	| {
			eventType: Exclude<EventType, EVENT_TYPE.OPERATIONAL>;
			nonPrivacySafeAttributes?: NonPrivacySafeAttributes;
	  }
	| { eventType: EVENT_TYPE.OPERATIONAL }
);

// Data portal: https://data-portal.internal.atlassian.com/analytics/registry/79629
type ReconnectionConflict = AEP<
	'offlineReconnectionConflict',
	ACTION_SUBJECT.EDITOR,
	undefined,
	{
		inserted: number;
		deleted: number;
	}
>;

// Add future monitoring required here (ie. resolving conflicts, applying changes etc.)
type ConflictPayload = ReconnectionConflict;

export const attachAnalyticsEvent =
	(api: EditorAnalyticsAPI | undefined) => (payload: ConflictPayload) => {
		return api?.attachAnalyticsEvent(payload as unknown as AnalyticsEventPayload);
	};
